import { Router, UrlMatcher, UrlSegment } from '@angular/router';
import { VendorSmartMicroAppName } from '../models/micro-app-name.model';
import { MicroAppNavigationProps } from '../models/navigation.model';
import { VendorSmartPages } from '../models/vendorsmart-pages.enum';

function getMicroAppRoute(appName: VendorSmartMicroAppName): string {
  switch (appName) {
    case VendorSmartMicroAppName.InvoiceSearch:
     return VendorSmartPages.InvoiceSearch;
   case VendorSmartMicroAppName.InvoiceDetails:
     return VendorSmartPages.InvoiceDetails;
   default:
     return '';
  }
}

export function handleMicroAppNavigation(
  router: Router,
  navigationDetails: MicroAppNavigationProps,
): void {
  router.navigate(
   [
     getMicroAppRoute(navigationDetails.appName),
     ...navigationDetails.route.split('/').filter(v => !!v),
   ],
   { queryParams: { ...navigationDetails.queryParams } },
  );
}

export function routeStartsWith(path: string): UrlMatcher {
  return (segments: UrlSegment[]) => {
    if (!segments.length) {
      return null;
    }
    return segments[0].path === path ? { consumed: segments } : { consumed: [] };
  };
}
